
// region JS Imports

// region External Modules
import $ from "jquery"
import u from "umbrellajs"
import Promise from "plugins/bluebird"
import L from "plugins/leaflet/index"
// endregion External Modules

// Private Modules
import Modal from "app/modal/show-modal"

import {
  q_ajax_3,
  ERROR_HANDLER_ACTIONS as AJAX_ERROR_HANDLER_ACTIONS,
} from "app/utils/q_ajax/q_ajax_3"
// Private Modules

// region Public Components
import TransitInfo_Modal from "concepts/cities/public_transport/modal/index"
// endregion Public Components

// region Private Components
import Map from "./components/map/index"
// endregion Private Components

// endregion JS Imports


const CELL_CLASS_NAME = "cell--cities--public-transport--info"
const CELL_INITIALIZED_CLASS_NAME = `${CELL_CLASS_NAME}--js-spacious-initialized`

interface PromiseOutput {
  maps_promise: Promise<L.Map[]>
}

const init = (): Promise<PromiseOutput> => {
  return new Promise((resolve) => {
    const maps_promises: Array<Promise<L.Map[]>> = u(`.${CELL_CLASS_NAME}`).nodes
    .reduce<Array<Promise<L.Map[]>>>((promises, el) => {
      const $el = u(el)

      if (el.classList.contains(CELL_INITIALIZED_CLASS_NAME)) { return promises }
      el.classList.add(CELL_INITIALIZED_CLASS_NAME)

      const $load_route_modal_buttons = $el.find(".cell--cities--public-transport--info__load-route-modal-button")

      // # Register the event
      $load_route_modal_buttons.on("click", (e) => {
        e.preventDefault()

        // `e.target` could be element inside anchor
        // To ensure it's the element we attached event listener on
        // Use `e.currentTarget`
        const $load_route_modal_button = u(e.currentTarget as HTMLElement)
        const url: string = $load_route_modal_button.attr("data-modal-url").toString() || $load_route_modal_button.attr("href").toString() || ""

        q_ajax_3({
          url:      url,
          method:   "GET",
          dataType: "html",
        })
        .then(({data}) => {
          Modal.showModalWithContent(data)
          TransitInfo_Modal.init()
        })
      })

      promises.push(
        Map.init({
          scope: el,
        }),
      )
      return promises
    }, [])

    resolve({
      maps_promise: Promise.all(maps_promises)
      .then((maps_of_maps) => {
        // Flatten the results
        return maps_of_maps.reduce((maps, all_maps) => {
          return all_maps.concat(maps)
        }, [])
      })
      .catch(() => {
        // It's ok that there is no map
        return []
      }),
    })
  })
}

export default {
  init,
}
